<div *ngIf="data">
  <ng-container ngSwitch="{{dialogType}}">
    <ng-container *ngSwitchCase="'confirm'">
      <h1 mat-dialog-title class="ll">{{data.title}}</h1>
      <div mat-dialog-content *ngIf="data.message">
        <p>{{data.message}}</p>
      </div>
      <div mat-dialog-content *ngIf="data.htmlMessage" [innerHTML]="data.htmlMessage">
      </div>
      <div mat-dialog-actions>
        <button *ngIf="data.isYesEnable" mat-button class="btns mat-raised-button" [mat-dialog-close]="data.actionYes" cdkFocusInitial>{{data.labelYes}}</button>
        <button mat-button class="btns mat-raised-button" (click)="onNoAction()">{{data.labelNo}}</button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'priceListEmail'">
      <div class="delete-product">
        <h1 mat-dialog-title class="padding-t20">{{data.title}}</h1>
        <div mat-dialog-content *ngIf="data.message">
          <p>{{data.message}}</p>
        </div>
        <div mat-dialog-content>
          <mat-form-field class="padding-l27 wide95" [ngClass]="{valid : (isNotValid ==false)}">
            <input matInput type="email" name="accountEmail"
                   placeholder="Email: {{defaultEmail}}"
                   [(ngModel)]="emails"
                   [readonly]="readOnlyAccess"
                   [pattern]="emailPattern"
                   (keyup)="validateEmail()">
            <mat-error *ngIf="isNotValid">
              Email not valid.
            </mat-error>
          </mat-form-field>
        </div>
        <div mat-dialog-actions>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="sendEmail(emails)">Send</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Cancel</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'email'">
      <div class="delete-product">
        <h1 mat-dialog-title class="padding-t20">{{data.title}}</h1>
        <div mat-dialog-content>
          <mat-form-field class="padding-l27 wide95" [ngClass]="{valid : (isNotValid ==false)}">
            <input matInput type="text" name="accountEmail" maxlength="250"
                   placeholder="Email:(Separate multiple email addresses by a semi-colon.)"
                   [(ngModel)]="emails"
                   [readonly]="readOnlyAccess"
                   [pattern]="emailPattern"
                   (blur)="validateEmail()">
            <mat-error *ngIf="isNotValid">
              This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
            </mat-error>
          </mat-form-field>
        </div>
        <div mat-dialog-actions>
          <button mat-raised-button mat-button class="btns mat-raised-button" [disabled]="isEmailIdEmpty" (click)="sendEmail(emails)">Send</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Cancel</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'nonSubscriberEmail'">
      <div class="delete-product">
        <h1 mat-dialog-title class="padding-t20">{{data.title}}</h1>
        <div mat-dialog-content>
          <mat-form-field class="padding-l27 wide95" [ngClass]="{valid : (isNotValid ==false)}">
            <mat-label>Non-Subscriber Email:</mat-label>
            <input matInput type="text" name="emails" maxlength="250"
                   placeholder="(Separate multiple email addresses by a semi-colon)"
                   [(ngModel)]="emails"
                   [readonly]="readOnlyAccess"
                   [pattern]="emailPattern"
                   (keyup)="validateEmail()"
                   (blur)="validateEmail()"
                   email="true">
            <mat-error *ngIf="isNotValid">
              This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
            </mat-error>
          </mat-form-field>
        </div>
        <div mat-dialog-actions>
          <button mat-raised-button mat-button class="btns mat-raised-button" [disabled]="isEmailIdEmpty || isNotValid" (click)="sendEmail(emails)">Send</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Cancel</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'gpJdeDetails'">
      <div class="delete-product">
        <h1 mat-dialog-title class="padding-t20">{{data.title}}</h1>
        <div mat-dialog-content class="dialog-body padding-l27">
          <span><strong>Credit Order Number : </strong>{{data.jdeOrderNumber}}</span><br />
          <span><strong>Order Type : </strong>{{data.jdeOrderType}}</span><br />
        </div>
        <div mat-dialog-actions>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Close</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
      <div class="delete-product" *ngIf="data.rows==1;else error">
        <h1 mat-dialog-title class="padding-t20">{{data.title}}</h1>
        <div mat-dialog-content>
          <div class="text-center deliveryDatePicker">
            <mat-form-field [class.invalid-field]="deliveryDate?false:true">
              <input [readonly]="readOnlyAccess" matInput [matDatepicker]="picker" [matDatepickerFilter]="dateFilter"
                     [(ngModel)]="deliveryDate">
              <mat-datepicker-toggle [disabled]="readOnlyAccess" matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker [disabled]="readOnlyAccess" #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div mat-dialog-actions>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="sendDate(deliveryDate)">Re Submit</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Cancel</button>
        </div>
      </div>
      <ng-template #error>
        <h1 mat-dialog-title class="padding-t20">{{data.title}}</h1>
        <div mat-dialog-content>
          <div class="text-center deliveryDatePicker">
            Can Process one item at a time. Please select only one item.
          </div>
        </div>
        <div mat-dialog-actions>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Ok</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Cancel</button>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="'quoteOrderApproveOrReject'">
      <button class="close" mat-button mat-dialog-close>
        <i class="fa fa-times fa-lg"></i>
      </button>
      <div mat-dialog-content class="dialog-body">
        <span><strong>Quote Number : {{data.quoteNumber}}</strong></span><br />
        <span><strong>Prepared For : {{data.preparedFor}}</strong></span><br />
        <div style="display: block;" class="mat-pb-0 xs-mt-5">
          <label>Comments:</label>
          <textarea style="resize:none;height:auto; width:100%" rows="2"
                    [maxLength]="500"
                    [(ngModel)]="comments" class="common-textarea" placeholder="*A reason for approving with exceptions or rejecting the quote must be entered."></textarea>
        </div>
      </div>
      <div mat-dialog-actions>
        <button mat-raised-button mat-button class="btns mat-raised-button" (click)="updateStatus(comments, 'Approved')">Approve</button>
        <button mat-raised-button mat-button class="btns mat-raised-button" (click)="updateStatus(comments,'Approved with Exception')">Approve w/Exceptions</button>
        <button mat-raised-button mat-button class="btns mat-raised-button" (click)="updateStatus(comments,'Rejected')">Reject</button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'sotRequestReject'">
      <div>
        <h2 class="sotRequestTitle">{{title}}:</h2>
      </div>
      <div>
        <textarea style="resize:none;height:auto; width:600px;" rows="8"
                  [maxLength]="3000"
                  [(ngModel)]="comments" class="common-textarea SotTextArea" placeholder="3000 character limit" required></textarea>
      </div>
      <div mat-dialog-actions class="SotDialog row">
        <div class="col-md-2">
        </div>
        <div class="col-md-10 pr-0 text-center text-md-right">
          <label *ngIf="(comments==null || comments==undefined || comments=='') && isShowMsg " class="sot-error-msg">*{{title}} are required</label>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="SOTUpdateRequest(comments, 'REJECTED')">Submit Request</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Close</button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'cotRequestReject'">
      <div>
        <h2 class="cotRequestTitle">{{title}}:</h2>
      </div>
      <div>
        <textarea style="resize:none;height:auto; width:600px;" rows="8"
                  [maxLength]="3000"
                  [(ngModel)]="comments" class="common-textarea CotTextArea" placeholder="3000 character limit" required></textarea>
      </div>
      <div mat-dialog-actions class="CotDialog row">
        <div class="col-md-2">
        </div>
        <div class="col-md-10 pr-0 text-center text-md-right">
          <label *ngIf="(comments==null || comments==undefined || comments=='') && isShowMsg " class="cot-error-msg">*{{title}} are required</label>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="COTUpdateRequest(comments, 'REJECTED')">Submit Request</button>
          <button mat-raised-button mat-button class="btns mat-raised-button" (click)="onNoAction()">Close</button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'repackItem'">
      <div class="row" style="margin: 6px 15px 15px 0;">
        <div class="col-11">
        </div>
        <div class="col-1">
          <div class="" style="cursor: pointer; font-size: 18px" (click)="onNoAction()"><i style="color: #0b3f54;" class="fas fa-times text-right"></i></div>
          <!--<h1 mat-dialog-title>{{data.title}}</h1>-->
        </div>
      </div>

      <div mat-dialog-content *ngIf="data.message" class="repack" style="padding: 0px 50px;">
        <p style="white-space: pre-line; text-align: center; line-height: 17px;font-weight: bold;">{{data.message}}</p>
      </div>
      <div mat-dialog-content *ngIf="data.htmlMessage" [innerHTML]="data.htmlMessage">
      </div>
      <div mat-dialog-actions class="removeBorder">
        <button *ngIf="data.isYesEnable" mat-button class="btns mat-raised-button xs-button" [mat-dialog-close]="data.actionYes" cdkFocusInitial>{{data.labelYes}}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'customerInventoryReportImportPopup'">
      <div class="row">
        <div class="col-12">
          <div class="customerInventoryReportTitle">
            Select a File to Import
          </div>
        </div>
        <div mat-dialog-content class="dialog-body">
          <div class="padding-l27 mat-pb-0 xs-mt-5">
            <input type="file" class="custom-file-input" id="importFile" #uploader hidden
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                   (click)="$event.target.value=null"
                   (change)="onFileSelect($event, data)">
            <label style="font-weight: bold; color: #004E7A">File:</label> <span *ngIf="isValidCirImportedFileName || data.importFileData"> {{data.importFileData.name}} <i title="Clear Selection File" style="font-size: 10px;padding-left:10px;" class="icon-ico-Close handCursor col-md-1" (click)="removeFileSelection(data)"></i></span>
            <div style="color:red;" *ngIf="isCirFileError">
              {{cirErrorMessage}}
            </div>
            <div style="color:red;" *ngIf="data.message && !isCirFileError">
              {{data.message}}
            </div>
          </div>
        </div>
        <div class="col-12" style="height: 54px; top: 0px;">
          <div class="" style="margin: 0px 30px;text-align: left;">
            <button mat-raised-button mat-button class="btns mat-raised-button w100" (click)="uploader.click()">Add File</button>
            <button mat-raised-button mat-button class="btns mat-raised-button margin-l20 w100" [disabled]="!isValidCirImportedFileName" (click)="validateColumnsAndLoadData()">OK</button>
            <button mat-raised-button mat-button class="btns mat-raised-button margin-l20 w100" (click)="closeCIRPopupAction()">Cancel</button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'acknowledgement'">
      <div mat-dialog-content *ngIf="data.message">
        <p><strong style="font-weight: 900;">{{data.message}}</strong></p>
      </div>
      <div mat-dialog-actions>
        <button *ngIf="data.isYesEnable" mat-button class="btns mat-raised-button" [mat-dialog-close]="data.actionYes" cdkFocusInitial>{{data.labelYes}}</button>
        <button mat-button class="btns mat-raised-button" (click)="onNoAction()">{{data.labelNo}}</button>
      </div>
    </ng-container>

    <!-- Evolve Survey form -->
    <ng-container *ngSwitchCase="'surveyForm'">
      <div class="dialog-container">
        <h2 mat-dialog-title>{{data.title}}</h2>
        <div mat-dialog-content>
          <p>{{data.message}}</p>
        </div>
        <div mat-dialog-actions>
          <button class="btns mat-raised-button" mat-button (click)="onSurveyResponse('YES')">{{data.labelYes}}</button>
          <button class="btns mat-raised-button" mat-button (click)="onSurveyResponse('NO')">{{data.labelNo}}</button>
          <button class="btns mat-raised-button" mat-button (click)="onSurveyResponse('LATER')">{{data.labelLater}}</button>
        </div>
      </div>
    </ng-container>

  </ng-container>
</div>
